export default "__VITE_ASSET__DFnFWeb0__"